export default __webpack_public_path__ + "61b24d789e79711acf8358875ac74c8e.png";